import React from "react";

import * as Table from "~/Table";
import { Time } from "~/Time";

export const Component: React.Fn<Time.Interval.Stopped> = (interval) => (
  <Table.Column.Component>
    <Time.Interval
      {...interval}
      Start={DateTime.Component}
      Stop={DateTime.Component}
    />
  </Table.Column.Component>
);

namespace DateTime {
  export const Component = (dateTime: Time.DateTime) => (
    <Time.DateTime {...dateTime} Date={() => null} Separator={() => null} />
  );
}
